import { LoadingIcon } from '@components/LoadingIcon'

export const LoadingPage = () => {
  return (
    <div className="w-full flex justify-center items-center h-full text-gray-400 dark:text-gray-500">
      <LoadingIcon className="h-8 w-8" />
    </div>
  )
}
